import React from 'react';
import type { FC } from 'react';

interface AvatarIconProps {
    className?: string;
}

export const AvatarIcon: FC<AvatarIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Avatar Icon</title>
            <circle cx="10" cy="10" r="6.5" stroke="white" />
            <path
                d="M12.9333 14V14C12.9333 13.2341 12.5708 12.5135 11.9559 12.0569L8.71667 9.65217L8.6574 9.60084C7.22221 8.35778 8.10133 6 10 6V6C11.8987 6 12.7778 8.35778 11.3426 9.60084L11.2833 9.65217L8.04413 12.0569C7.4292 12.5135 7.06667 13.2341 7.06667 14V14"
                stroke="white"
            />
        </svg>
    );
};
